import { SHAPE_STROKE_PROPS } from './stroke-props';

interface CrossProps {
  strokeDasharray: string | undefined;
}

export default function Cross({ strokeDasharray }: CrossProps) {
  return (
    <polygon
      points="35,0 65,0 65,35 100,35 100,65 65,65 65,100 35,100 35,65 0,65 0,35 35,35"
      strokeDasharray={strokeDasharray}
      {...SHAPE_STROKE_PROPS}
    />
  );
}
